import styled, { css } from 'styled-components';
import { media } from '../../utils';

export const RecommendSection = styled.div`
  margin: 0 4% 4%;
  padding: 24px;
  background: linear-gradient(135deg, rgba(51, 255, 153, 0.05), rgba(0, 0, 53, 0.8));
  border: 1px solid rgba(51, 255, 153, 0.15);
  border-radius: 16px;

  ${media('mobile')} {
    margin: 0 15px 30px;
    padding: 16px;
  }
`;

export const SectionHeader = styled.div`
  margin-bottom: 16px;
`;

export const SectionTitle = styled.h2`
  font-size: 1.8em;
  font-weight: bold;
  color: #fff;
  margin-bottom: 6px;

  ${media('mobile')} {
    font-size: 1.3em;
  }
`;

export const SectionSubtitle = styled.p`
  font-size: 0.9rem;
  color: rgba(255, 255, 255, 0.5);
`;

export const PromptButtons = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const PromptBtn = styled.button<{ $active: boolean }>`
  padding: 10px 18px;
  border-radius: 25px;
  font-size: 0.9rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s;
  border: 1px solid rgba(51, 255, 153, 0.3);

  ${({ $active }) => $active
    ? css`
        background: rgba(51, 255, 153, 0.2);
        color: #33ff99;
        border-color: #33ff99;
      `
    : css`
        background: rgba(255, 255, 255, 0.05);
        color: #ccc;
      `
  }

  &:hover:not(:disabled) {
    background: rgba(51, 255, 153, 0.15);
    color: #33ff99;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ResultBox = styled.div`
  padding: 18px;
  background: rgba(0, 0, 0, 0.3);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.05);
`;

export const LoadingText = styled.div`
  color: #33ff99;
  font-size: 0.95rem;
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const RecommendText = styled.div`
  color: #e0e0e0;
  font-size: 0.95rem;
  line-height: 1.7;
  white-space: pre-wrap;
`;
